import { render, staticRenderFns } from "./PackageOrCaseField.vue?vue&type=template&id=5b1333c9"
import script from "./PackageOrCaseField.vue?vue&type=script&lang=js"
export * from "./PackageOrCaseField.vue?vue&type=script&lang=js"
import style0 from "./PackageOrCaseField.vue?vue&type=style&index=0&id=5b1333c9&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports